import { mergeStringTables, type StringTable } from '../../../shared';
import { app } from './app';
import { cards } from './cards';
import { combat } from './combat';
import { explore } from './explore';
import { meta } from './meta';
import { ui } from './ui';
import { equipment } from './equipment';
export const EN_MODULES: Readonly<Record<string, StringTable>> = {
  app, cards, combat, explore, meta, ui, equipment,
  creature: { 'creature.screen.make': 'Appearance', 'creature.screen.animlab': 'Animation workshop' },
  debug: { 'debug.screen.artlab': 'Art workshop' },
};
export const EN_STRINGS: StringTable = mergeStringTables(...Object.values(EN_MODULES));
